import setChiclet from "../helpers/chiclet.js";

const brookingsDateMenu = instantsearch.connectors.connectNumericMenu(
	(renderOptions, isFirstRender) => {
		const { items, canRefine, refine, widgetParams } = renderOptions;

		if ( ! brookingsAlgoliaFeedOptions.facets.includes('date') ) {
			return;
		}

		if ( isFirstRender ) {
			document.querySelector('#dateFacets').classList.add('active');
		}

		if ( ! isFirstRender && items.length > 0 ) {
			items.forEach( (item) => {
				setChiclet(item,widgetParams.attribute,refine);
			});
		}
		
		document.querySelector('#facet-dates').innerHTML = `
			${items.map(
				item => `
				<label class="inline-radio">
					<input class="form-radio" type="radio" name="${widgetParams.attribute}" value="${item.value}" ${item.isRefined ? 'checked' : ''}
					${!canRefine ? 'disabled' : ''}>
					<span class="">${item.label}</span>
				</label>`
			).join('')}
		`;
		[...widgetParams.container.querySelectorAll('input')].forEach(element => {
			element.addEventListener('change', event => {
			  refine(event.currentTarget.value);
			});
		});
	}
);

export default brookingsDateMenu;